import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PropTypes from 'prop-types';

import AmenityReservationsComponent from './AmenityReservationsComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import {
  clearAmenities,
  confirmAction,
  getAmenities,
  getAmenityReservations,
  onGetReservationsCalendar,
  removeReservation,
  setAmenityStatus,
} from './actions';

import { filterObjectByKeyValue, getTodayCount } from '../../utils';

const LIST_KEY = 'amenityReservations';

const AmenityReservationsContainer = (props) => {
  const location = useLocation();
  const {
    clearAmenities,
    onConfirmRemoveReservation,
    onGetAmenityReservations,
    listParams,
    onSetAmenityStatus,
    getItems,
  } = props;

  useEffect(() => () => clearAmenities(), []);

  const onRemoveReservation = (data) => {
    const bodyText =
      'Are you certain this amenity reservation should be deleted?';
    return onConfirmRemoveReservation(bodyText, data, removeReservation);
  };

  const onAmenityReservationsExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetAmenityReservations(queryParams);
  };

  const onAmenityStatusChange = async (id, status) => {
    const response = await onSetAmenityStatus(id, status);
    if (response) getItems(listParams);
  };

  return (
    <AmenityReservationsComponent
      key={location.key}
      {...props}
      onRemoveReservation={onRemoveReservation}
      onAmenityReservationsExport={onAmenityReservationsExport}
      onAmenityStatusChange={onAmenityStatusChange}
    />
  );
};

AmenityReservationsContainer.propTypes = {
  clearAmenities: PropTypes.func.isRequired,
  onConfirmRemoveReservation: PropTypes.func.isRequired,
  onGetAmenityReservations: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  onSetAmenityStatus: PropTypes.func.isRequired,
  getItems: PropTypes.func.isRequired,
};

const mapStateToProps = ({ amenity, pmcs, buildings, lists }, ownProps) => {
  const listParams = lists?.[LIST_KEY] ?? {};
  const pmcId = ownProps?.match?.params?.PMCId;
  const buildingId = ownProps?.match?.params?.buildingId;
  const preselectedAmenityId = ownProps?.amenityId;
  const pmc = pmcId && pmcs?.[pmcId];
  const building = buildingId && buildings?.[buildingId];
  const isCalendarView = ownProps?.location?.pathname?.includes('/calendar');
  return {
    pmcId,
    buildingId,
    pmc,
    building,
    listKey: LIST_KEY,
    listParams,
    items: amenity?.amenityReservations ?? {},
    buildings: pmcId
      ? filterObjectByKeyValue(buildings, 'parent.id', +pmcId)
      : buildings,
    amenities: amenity?.amenities ?? [],
    preselectedAmenityId,
    isCalendarView,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const buildingId = ownProps?.match?.params?.buildingId;
  const pmcId = ownProps?.match?.params?.PMCId;
  const isCalendarView = ownProps?.location?.pathname?.includes('/calendar');

  return {
    onLoad: (params) => {
      !buildingId && getBuildingsForFilter(dispatch, params);
      getAmenities(dispatch, {
        ...params,
        disable_pagination: true,
        building: buildingId,
        pmc: pmcId,
      });
    },
    getItems: (queryParams) => {
      if (isCalendarView) {
        return onGetReservationsCalendar(dispatch, queryParams);
      }
      getAmenityReservations(dispatch, queryParams, false, isCalendarView);
      return getTodayCount(getAmenityReservations, dispatch, queryParams);
    },
    onGetAmenityReservations: (queryParams) =>
      getAmenityReservations(dispatch, queryParams, true),
    onConfirmRemoveReservation: (bodyText, data, callback) =>
      confirmAction(dispatch, bodyText, data, callback),
    clearAmenities: () => clearAmenities(dispatch),
    onSetAmenityStatus: (id, status) => setAmenityStatus(dispatch, id, status),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AmenityReservationsContainer);
